import React from 'react';
import { Phone } from 'lucide-react';

const FloatingCallButton = () => {
  return (
    <a 
      href="tel:07834618908"
      className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-emerald-500/50 transition-all duration-300 hover:scale-110 flex items-center gap-3 group"
      aria-label="Call now"
    >
      <Phone className="h-6 w-6 animate-pulse" />
      <span className="font-bold text-lg hidden sm:inline-block">07834 618908</span>
    </a>
  );
};

export default FloatingCallButton;
